import VueRouter from 'vue-router';
import Vue from 'vue';

import TechCompanies from '../../components/tech-companies/App.vue';
import Index from '../../components/tech-companies/Index.vue';
import Stage from '../../components/tech-companies/Stage.vue';
import Vertical from '../../components/tech-companies/Vertical.vue';
import Company from '../../components/tech-companies/Company.vue';

import store from '../../components/tech-companies/store';

const $ = jQuery;

export default {
	init(el, props){

		const routes = [
			{name: 'index', path: '/', component: Index},
			{name: 'stage', path: '/stage/:stage_slug', component: Stage, props: true},
			{name: 'vertical', path: '/vertical/:vertical_slug(.*)', component: Vertical, props: true},
			{name: 'company', path: '/company/:slug', component: Company, props: true}
		];

		const router = new VueRouter({
			routes,
			base: '/asa-staffing-tech-center/staffing-technology-ecosystem',
			mode: 'history',
			scrollBehavior (to, from, savedPosition) {
				if (savedPosition) {
					return savedPosition
				} else {
					return { x: 0, y: 0 }
				}
			}
		})

		store.setTechStack( props.techStack );
		store.setExtraPanel( props.extraPanel );
		store.setIntroduction( props.introduction );

		if( window.companyData ){
			console.log( 'setCompany', window.companyData );
			store.setCompany( window.companyData );
		}

		window.techCompanyStore = store;
		
		Vue.use(VueRouter);

		const app = new Vue({
			router,
			el,
			render: function (h) {
				return h(TechCompanies, {propData: props});
			}
		});

	}
}